"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stdlib_core_1 = require("@groupby/stdlib-core");
class UnsupportedMediaTypeException extends stdlib_core_1.Exception {
    constructor(message) {
        super(message);
        this[Symbol.toStringTag] = 'UnsupportedMediaTypeException';
        this.name = 'UnsupportedMediaTypeException';
    }
}
exports.UnsupportedMediaTypeException = UnsupportedMediaTypeException;
//# sourceMappingURL=unsupported-media-type-exception.js.map